import { Component, OnInit, Input, OnChanges, SimpleChanges } from "@angular/core";
import { BaseModel, FormGeneratorService } from "@ngx-resource-toolkit/core";
import { FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { ToasterService } from "angular2-toaster";
import { SettingsService } from "../../core/settings/settings.service";
import { ProfesseurModel } from "../../professeur/models/professeur.model";
import { DateHelper } from "../helpers/date.helper";
import * as moment from 'moment';
import { CoursModel } from "../../cours/models/cours.model";

@Component({
    selector: 'occupation',
    templateUrl: './occupation.component.html',
    // styleUrls: ['occupation.component.scss']
})
export class OccupationComponent implements OnInit, OnChanges {

    @Input() professeur: ProfesseurModel;


    public startDate: moment.Moment;
    public endDate: moment.Moment;

    public set period(value: moment.unitOfTime.StartOf) {
        if (this._period != value) {
            this._period = value;
            this.setDateBounds();
            this.fetchOccupation();
        }
    }
    public get period(): moment.unitOfTime.StartOf {
        return this._period;
    }
    private _period: moment.unitOfTime.StartOf = 'isoWeek';

    public DateHelper = DateHelper;

    constructor(
        private settings: SettingsService,
        private toaster: ToasterService,
        private http: HttpClient,
        private formGenerator: FormGeneratorService) {

    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.professeur) {
            this.setDateBounds();
            this.fetchOccupation();
        }
    }

    setDateBounds() {
        this.startDate = moment().startOf(this.period);
        this.endDate = moment().endOf(this.period);
    }

    moveDates(method) {
        if (method != 'add' && method != 'subtract')
            throw new Error(`moveDates method is unknown ${method}`);

        switch(this.period) {
            default:
            case 'isoWeek':
                this.startDate[method](1, 'weeks');
                this.endDate[method](1, 'weeks');
                break;

            case 'month':
                this.startDate[method](1, 'months');
                this.endDate[method](1, 'months');
                break;
        }
        this.fetchOccupation();
    }

    fetchOccupation() {
        const coursRessource: CoursModel = new CoursModel();
        console.log('fetchOccupation', this.professeur);
        if (this.professeur.id) {
            coursRessource.getResource('default', 'get').call(this.http, 'calculProfesseurTotalDureeCours', [
                this.professeur.id,
                this.startDate.format('YYYY-MM-DD'),
                this.endDate.format('YYYY-MM-DD'),
                this.settings.getUserSetting('anneeScolaire'),
            ]).subscribe((data) => {
                this.professeur.heurePrevue = data;
            }, (err) => {
                console.log('OccupationComponent', 'calcul error', err);
                this.toaster.pop('error', 'Une erreur est survenue lors du calcul de l\'occupation');
            });
        }
    }


    private getWidth() {
        return this.professeur.heureContrat ?
            this.professeur.heurePrevue <= this.professeur.heureContrat ?
                {
                    filled: Math.floor((this.professeur.heurePrevue/this.professeur.heureContrat)*100) + '%',
                    overflow: 100 - Math.floor((this.professeur.heurePrevue/this.professeur.heureContrat)*100) + '%',
                } : {
                    filled: 100 - Math.floor((this.professeur.heurePrevue - this.professeur.heureContrat)*100/this.professeur.heureContrat) + '%',
                    overflow: Math.floor((this.professeur.heurePrevue - this.professeur.heureContrat)*100/this.professeur.heureContrat) + '%',
                }

            : {
                filled: 0,
                overflow: 100 + '%',
            }
    }

}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/occupation/occupation.component.ts